import { Component, HostListener, signal, inject, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ThemeService } from '../../services/theme.service';
import { ContentService } from '../../services/content.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header implements OnInit {

  themeService = inject(ThemeService);
  contentService = inject(ContentService);
  
  isMenuOpen = signal(false);
  isScrolled = signal(false);
  isMegamenuOpen = signal(false);
  logoUrl = signal('/images/logo.png');

  ngOnInit() {
    this.contentService.getHomeContent().subscribe({
      next: (data) => {
        if (data && data.logoImage) {
          const url = data.logoImage.startsWith('http') ? data.logoImage : 'https://dev.thehuskbakery.com/' + data.logoImage;
          this.logoUrl.set(url);
        }
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled.set(window.scrollY > 50);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.has-dropdown') && this.isMegamenuOpen()) {
      this.closeMegamenu();
    }
  }

  toggleMenu() {
    this.isMenuOpen.update(open => !open);
  }

  closeMenu() {
    this.isMenuOpen.set(false);
    this.closeMegamenu();
  }

  toggleMegamenu(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.isMegamenuOpen.update(open => !open);
  }

  closeMegamenu() {
    this.isMegamenuOpen.set(false);
  }
}
